import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader } from "../../Components/Shimmer";

const InspectionInfo = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const { project_visit_id } = useParams();
    const navigate = useNavigate();

    const [loadingList, setLoadingList] = useState(false);
    const [visitInfo, setVisitInfo] = useState({});
    const [attachments, setAttachments] = useState([]);

    const GetInfo = async () => {
        try {
            setLoadingList(true);

            const response = await axios.get(
                `${apiURL}api/GetProjectVisitInfo`,
                {
                    params: { project_visit_id },
                    headers: apiHeaderJson,
                }
            );

            const { data, success, attachments } = response.data;

            if (success) {
                setVisitInfo(data || {});
                setAttachments(attachments || []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        if (project_visit_id) GetInfo();
    }, [project_visit_id]);

    const formatDate = (value) => {
        if (!value) return "-";

        const date = new Date(value.replace(" ", "T"));

        if (isNaN(date.getTime())) return "-";

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const formatTime = (value) => {
        if (!value) return "-";

        const date = new Date(value.replace(" ", "T"));

        if (isNaN(date.getTime())) return "-";

        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const signatureUrl = visitInfo?.digital_signature
        ? `${apiURL}api/profile-signature/${visitInfo.digital_signature}`
        : null;

    const getAttachmentUrl = (file) =>
        `${apiURL}public/project_visits/${file}`;

    if (loadingList) {
        return <ContentLoader />;
    }

    return (
        <div className="container-fluid py-3 bg-light min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card border shadow-sm">

                            {/* Header */}
                            <div className="card-header bg-white py-3">
                                <div className="d-flex align-items-center justify-content-between">

                                    <div className="d-flex align-items-center gap-3">
                                        <img
                                            src="/assets/images/new_logo.png"
                                            alt="Logo"
                                            style={{
                                                maxHeight: "55px",
                                                maxWidth: "160px",
                                            }}
                                        />

                                        <div className="border-start ps-3">
                                            <h5 className="mb-1 fw-bold">
                                                Inspection Details
                                            </h5>
                                            <div className="text-muted small">
                                                Inspection / Site Visit
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="card-body p-4">

                                {/* Inspection Details */}
                                <div className="mb-4">

                                    <h6 className="fw-bold border-bottom pb-2 mb-3">
                                        Inspection Details
                                    </h6>

                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <div className="text-muted small">
                                                Inspection Date
                                            </div>
                                            <div className="fw-semibold">
                                                {formatDate(visitInfo?.visit_datetime)}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="text-muted small">
                                                Inspection Time
                                            </div>
                                            <div className="fw-semibold">
                                                {formatTime(visitInfo?.visit_datetime)}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="text-muted small">
                                                Visit Remark
                                            </div>
                                            <div className="fw-semibold mt-1 py-4 px-2 bg-light">
                                                {visitInfo?.visit_remark || "-"}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* Consultant */}
                                <div className="mb-4">

                                    <h6 className="fw-bold border-bottom pb-2 mb-3">
                                        Consultant Details
                                    </h6>

                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <div className="text-muted small">
                                                Consultant Name
                                            </div>
                                            <div className="fw-semibold">
                                                {visitInfo?.profile_name || "-"}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="text-muted small">
                                                Consultant Name
                                            </div>

                                            <div
                                                className="border rounded d-flex align-items-center justify-content-center bg-light"
                                                style={{
                                                    width: "300px",
                                                    height: "140px",
                                                }}
                                            >
                                                {signatureUrl ? (
                                                    <img
                                                        src={signatureUrl}
                                                        alt="Consultant Signature"
                                                        className="img-fluid"
                                                        style={{
                                                            maxWidth: "280px",
                                                            maxHeight: "120px",
                                                            objectFit: "contain",
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = "none";
                                                        }}
                                                    />
                                                ) : (
                                                    <span className="text-muted small">
                                                        No Signature Available
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* Signature */}
                                <div className="mb-4">



                                </div>

                                {/* Attachments */}
                                {/* Attachments */}
                                {/* Attachments */}
                                <div className="mb-4">
                                    <h6 className="fw-bold border-bottom pb-2 mb-3">
                                        Attachments
                                    </h6>

                                    {attachments?.length > 0 ? (
                                        <div className="row g-3">
                                            {attachments.map((item, index) => {
                                                const attachmentUrl = getAttachmentUrl(
                                                    item.project_visit_attachment
                                                );

                                                const fileName = item.project_visit_attachment || "";
                                                const isPdf = fileName.toLowerCase().endsWith(".pdf");

                                                return (
                                                    <div
                                                        className="col-md-4 col-sm-6"
                                                        key={item.project_visit_attachment_id}
                                                    >
                                                        <a
                                                            href={attachmentUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-decoration-none"
                                                        >
                                                            <div className="card border h-100 shadow-sm">

                                                                {isPdf ? (
                                                                    <div
                                                                        className="d-flex flex-column align-items-center justify-content-center bg-light"
                                                                        style={{ height: "180px" }}
                                                                    >
                                                                        <i
                                                                            className="ri-file-pdf-2-line text-danger"
                                                                            style={{ fontSize: "60px" }}
                                                                        />

                                                                        <span className="text-danger fw-semibold mt-2">
                                                                            PDF Document
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={attachmentUrl}
                                                                        alt={`Attachment ${index + 1}`}
                                                                        className="card-img-top"
                                                                        style={{
                                                                            height: "180px",
                                                                            objectFit: "contain",
                                                                            backgroundColor: "#f8f9fa",
                                                                        }}
                                                                    />
                                                                )}

                                                                <div className="card-body py-2 text-center">
                                                                    <div className="text-dark fw-semibold small text-truncate">
                                                                        {fileName}
                                                                    </div>

                                                                    <div className="text-primary small">
                                                                        Click to view
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-muted">
                                            No attachments available.
                                        </div>
                                    )}
                                </div>

                                {/* Buttons */}
                                <div className="d-flex justify-content-end gap-2 mt-4 d-print-none">

                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className="ri-arrow-go-back-line me-1" />
                                        Go Back
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => window.print()}
                                    >
                                        <i className="ri-printer-line me-1" />
                                        Print
                                    </button>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {/* Print only */}
            <style>
                {`
                    @media print {
                        @page {
                            size: A4;
                            margin: 12mm;
                        }

                        body {
                            background: #fff !important;
                        }

                        .container-fluid {
                            background: #fff !important;
                            min-height: auto !important;
                            padding: 0 !important;
                        }

                        .container {
                            max-width: 100% !important;
                            padding: 0 !important;
                        }

                        .card {
                            box-shadow: none !important;
                            border: 1px solid #dee2e6 !important;
                        }

                        .card-header {
                            background: #fff !important;
                        }

                        .d-print-none {
                            display: none !important;
                        }

                        a {
                            color: inherit !important;
                            text-decoration: none !important;
                        }

                        a[href]::after {
                            content: none !important;
                        }

                        .card {
                            break-inside: avoid;
                        }

                        .mb-4 {
                            break-inside: avoid;
                        }

                        img {
                            break-inside: avoid;
                        }
                    }
                `}
            </style>

        </div>
    );
};

export default InspectionInfo;